// extracted by mini-css-extract-plugin
module.exports = {"icon":"onfido-sdk-ui-crossDevice-ClientSuccess-icon","text":"onfido-sdk-ui-crossDevice-ClientSuccess-text"};